
const reasons = [
  {
    id: 1,
    icon: 'ri-money-pound-circle-line',
    title: 'Best Value Guaranteed',
    description: 'We bypass mainstream booking platforms to find hidden, budget-friendly options that offer maximum value for Pakistani families.',
  },
  {
    id: 2,
    icon: 'ri-restaurant-line',
    title: 'Halal-Focused Selection',
    description: 'Every accommodation is vetted for proximity to halal restaurants, mosques, and culturally appropriate amenities.',
  },
  {
    id: 3,
    icon: 'ri-parent-line',
    title: 'Family-Centric Approach',
    description: 'Spacious room configurations, family-friendly locations, and services designed with multi-generational travel in mind.',
  },
  {
    id: 4,
    icon: 'ri-customer-service-2-line',
    title: 'Urdu-Speaking Support',
    description: 'Our team speaks Urdu and understands the unique needs of Pakistani families visiting the UK.',
  },
  {
    id: 5,
    icon: 'ri-map-2-line',
    title: 'Local Expertise',
    description: 'Based in London, we have first-hand knowledge of the best areas, transport links, and hidden gems.',
  },
  {
    id: 6,
    icon: 'ri-shield-check-line',
    title: 'Trusted & Reliable',
    description: 'Part of Alwaz Travel London, trusted by thousands of families across Europe for quality travel services.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-[#FFFBF0]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-2 bg-[#C9A961]/10 text-[#C9A961] text-sm font-medium rounded-full mb-4">
              Why Choose Us
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F2E] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Your Trusted London Travel Partner
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Navigating London&apos;s expensive hospitality market requires strategic planning. We specialise in helping overseas Pakistani families find affordable, culturally appropriate accommodation and services.
            </p>
            <div className="relative h-80 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/b94ef616a3a1024ffbb33bd0568e70b6.jpg"
                alt="Pakistani family in London"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid gap-6">
            {reasons.map((reason) => (
              <div
                key={reason.id}
                className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 bg-[#C9A961]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${reason.icon} text-xl text-[#C9A961]`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A1F2E] mb-2">{reason.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
